// @ts-nocheck
import { node } from "~/util/dom";
import { CONFIG } from "~/config";
import ControlLayer from "./control-layer";
import ControlZoom from "./control-zoom";
import ControlBestfit from "./control-bestfit";
import DetailMarker from "./detail-marker";
import Markers from "./markers";
import { lookupbox } from "~/util/providers/poiagg";
import { store } from "~/photo/globals";
import { setPoiGallery } from "~/state/gallery/state";
import { getLogoPath } from "~/util/userweb";

const LAYERS = [SMap.DEF_BASE, SMap.DEF_OPHOTO, SMap.DEF_TURIST];
/**
 * Mapa do galerie (leva cast)
 */

export default class Map {
	constructor(className = "map", options = {}) {
		this._node = Mapy.Util.node("div", { className });
		this._smap = new SMap(this._node);
		this._markers = new Markers(this._smap);
		this._markerDetail = null;
		this._activeLayer = -1;
		this._sl = null;
		this._userPublicId = "";
		this._POI = null;
		this._myGallery = false;
		this._hoverMarker = null;
		this._request = null;
		this._geomLayer = new SMap.Layer.Geometry();

		this._layers = [
			this._smap.addDefaultLayer(LAYERS[0]),
			this._smap.addDefaultLayer(LAYERS[1]),
			this._smap.addDefaultLayer(LAYERS[2]),
		];

		if (options.showControls) {
			this._smap.setPadding("top", 46);
			this._smap.setPadding("bottom", 32);
			this._smap.setPadding("left", 28);
			this._smap.setPadding("right", 28);

			this._keyboardControl = new SMap.Control.Keyboard(SMap.KB_PAN | SMap.KB_ZOOM, { focusedOnly: false });

			this._smap.addControl(new SMap.Control.Mouse(SMap.MOUSE_PAN | SMap.MOUSE_WHEEL | SMap.MOUSE_ZOOM));
			this.controlKeyboard(true);
			this._smap.addControl(new SMap.Control.Selection(2));
			this._smap.addControl(new ControlZoom(this._smap));
			this._controlLayer = new ControlLayer();
			this._controlLayer.getContainer().addEventListener("change-layer", this, false);

			this._smap.addControl(this._controlLayer);

			this._controlBestfit = new ControlBestfit();
			this._controlBestfit.getContainer().addEventListener("best-fit", this, false);

			if (CONFIG?.printMode === 3) {
				const logo = node("img", { src: `/img/logo${getLogoPath()}/logo-print.svg` });

				logo.style.position = "absolute";
				logo.style.bottom = "10px";
				logo.style.right = "10px";
				this._node.append(logo);
			}
		} else {
			this._smap.setPadding("top", 10);
			this._smap.setPadding("bottom", 10);
			this._smap.setPadding("left", 10);
			this._smap.setPadding("right", 10);
		}

		this._smap.setZoomRange(2, 19);

		this._smap.addLayer(this._markers.layers.dimm).enable();
		this._smap.addLayer(this._markers.layers.marker).enable();
		this._smap.addLayer(this._geomLayer).enable();

		const [longitude, latitude] = this._smap.getCenter().toWGS84();

		Mapy.getComponent("imageUploader").setMapCoords({
			longitude,
			latitude,
			zoom: this._smap.getZoom(),
		});

		this._changeLayer(0);
	}

	destroy() {
		Mapy.Util.clear(this._node);
		if (this._markerDetail) {
			this._markerDetail.layer.disable();
			this._smap.removeLayer(this._markerDetail.layer);
			this._markerDetail.destroy();
		}

		for (const layer in this._markers.layers) {
			if (this._markers.layers[layer]) {
				this._markers.layers[layer].disable();
				this._smap.removeLayer(this._markers.layers[layer]);
			}
		}

		this._markers.destroy();

		this._userPublicId = "";
		this._POI = null;
		this._hoverMarker = null;

		this._removeSignalListener();
		this._smap.$destructor();

		if (this._controlLayer) {
			this._controlLayer.getContainer().removeEventListener("change-layer", this, false);
			this._controlLayer.destroy();
		}

		if (this._controlBestfit) {
			this._controlBestfit.getContainer().removeEventListener("best-fit", this, false);
			this._controlBestfit.destroy();
		}

		Mapy.getComponent("imageUploader").setMapCoords(null);
	}

	get node() {
		return this._node;
	}

	set centerZoom(props) {
		const centerzoom = this.centerZoom;

		if (centerzoom.coords[0] !== props.coords[0] || centerzoom.coords[1] !== props.coords[1] || centerzoom.zoom !== props.zoom) {
			this._smap.setCenterZoom(SMap.Coords.fromWGS84(props.coords[0], props.coords[1]), props.zoom, props.animate);
		}

		Mapy.getComponent("imageUploader").setMapCoords({
			longitude: props.coords[0],
			latitude: props.coords[1],
			zoom: props.zoom,
		});
	}

	get centerZoom() {
		return {
			coords: this._smap.getCenter().toWGS84(),
			zoom: this._smap.getZoom(),
		};
	}

	set detailMarker(data) {
		if (data.geom) {
			this._geomLayer.removeAll();

			const newGeom = SMap.Geometry.Multi.fromData({ geom: {
				...data.geom,
				type: "multilinestring",
			} }, {
				width: 3,
				opacity: 1,
				style: 0,
				color: "red",
				outlineWidth: 3,
				outlineStyle: JAK.Vector.STYLE_SOLID,
				outlineColor: "white",
				outlineOpacity: 1,
			});

			this._geomLayer.addGeometry(newGeom);
		} else {
			if (!this._markerDetail) {
				this._markerDetail = new DetailMarker();
				this._smap.addLayer(this._markerDetail.layer).enable();
			}

			this._markerDetail.data = data;
		}
	}

	set layer(index) {
		this._changeLayer(index);
	}

	get activeLayer() {
		return this._activeLayer;
	}

	set userPublicId(id) {
		this._userPublicId = id;
		this._addMapRedraw();
	}

	set my(my) {
		this._myGallery = my;
	}

	set POI({ source, id }) {
		this._POI = {
			source,
			id,
		};
		this._addMapRedraw();
	}

	clearMarkers() {
		this._markers.clear();
	}

	addMarkers(markers: Array<IFotoPOIData>, clearMap = false) {
		this._markers.addMarkers(markers, clearMap);

		if (this._hoverMarker) {
			this._markers.hover(this._hoverMarker.source, this._hoverMarker.id, this._hoverMarker.data);
		}
	}

	computeCenterZoom(coords) {
		return this._smap.computeCenterZoom(coords);
	}

	sync() {
		this._smap.syncPort();
	}

	hoverMarker(source, id, data) {
		this._markers.hover(source, id, data);
		this._hoverMarker = source
			? {
				source,
				id,
				data,
			}
			: null;
	}

	controlKeyboard(on) {
		if (this._keyboardControl) {
			this._smap[on ? "addControl" : "removeControl"](this._keyboardControl);
		}
	}

	showBestFitControl() {
		this._smap.removeControl(this._controlBestfit);
		this._smap.addControl(this._controlBestfit);
	}

	handleEvent(event) {
		if (event.type === "change-layer") {
			this._changeLayer(event.detail);
		}

		if (event.type === "best-fit") {
			this._smap.removeControl(this._controlBestfit);

			const customEvent = new CustomEvent("best-fit");

			this._node.dispatchEvent(customEvent);

			Mapy.getComponent("logger").log("click", Object.assign(Mapy.getComponent("gallery").logData, {
				text: "bestfitMap",
			}));
		}
	}

	_changeLayer(index = 0) {
		if (index !== this._activeLayer) {
			if (this._activeLayer >= 0) {
				this._layers[this._activeLayer].disable();
			}
			this._layers[index].enable();

			this._smap.getLayerContainer(SMap.LAYER_TILE).classList[index === 0 ? "add" : "remove"]("base");

			this._activeLayer = index;

			this._markers?.layers?.dimm?.getContainer()[SMap.LAYER_MARKER].classList[LAYERS[index] === SMap.DEF_BASE ? "add" : "remove"]("active-dimm");
		}
	}

	_mapRedraw() {
		const zoom = this._smap.getZoom();
		const [longitude, latitude] = this._smap.getCenter().toWGS84();

		Mapy.getComponent("imageUploader").setMapCoords({
			longitude,
			latitude,
			zoom,
		});

		// test
		if (this._POI?.source === "firm") {
			return;
		}

		const viewport = this._smap.getViewport();
		const opts = {
			zoom,
			mapsetId: this._activeLayer > -1 ? LAYERS[this._activeLayer] : 26,
			sources: ["foto"],
		};

		if (this._userPublicId !== "") {
			opts.userPublicId = this._userPublicId;
		} else if (this._POI) {
			opts.poiSource = this._POI.source;
			opts.poiId = this._POI.id;
		}

		if (!this._myGallery) {
			opts.approval = true;
		}

		// pouze lookupbox pro fotky, ne poie!
		if (this._request) {
			this._request.abort();
			this._request = null;
		}

		const lookupboxData = lookupbox(viewport.lbx, viewport.lby, viewport.rtx, viewport.rty, opts);

		this._request = lookupboxData.request;
		lookupboxData.promise.then(data => {
			store.dispatch(setPoiGallery({
				poiGallery: data.poi,
				poiGalleryInd: 0,
			}));
		}, () => {});
	}

	_addMapRedraw() {
		this._removeSignalListener();
		this._smap.getSignals().addListener(this, "map-redraw", "_mapRedraw");
	}

	_removeSignalListener() {
		if (this._sl) {
			this._smap.getSignals().removeListener(this._sl);
		}
	}
}
